import { Link } from "react-router-dom";
import { RAPSHighlightsType } from "../../../../models/raps-highlights-model"


const EuropeLeftSec = (props: {content: RAPSHighlightsType}) => {
    const content = props.content;
    return (
        <div className="hero-featurette hero-primary">
            <div className="featured-image" style={{ backgroundImage: `url(${content.image})` }}>
                <div className="hero-content">
                    <strong className="title"><Link to={content.linkURL}>{content.title}</Link></strong>
                    <p className="summary">{content.content}</p>
                    <p><Link to={content.linkURL} className="btn btn-default" role="button">{content.linkText}</Link></p>
                </div>
            </div>
        </div>
    )
}

export default EuropeLeftSec
